<template>
  <div class="d-flex justify-content-center align-items-center vh-100 login-background">
    <img src="../../assets/images/spinner_purple_64x64.gif" class="spinner shadow rounded-circle">
  </div>
</template>

<script>
import { mapActions } from "vuex";
import store from "../../store/store";

export default {
  name: "LoginExternal",
  props: {
    'authToken': null,
  },
  'methods': {
    ...mapActions([
      'loginExternal',
    ]),
  },
  created() {
    if (this.authToken) {
      store.commit('removeLoggedUser')
      store.commit('removeaccessToken')

      this.loginExternal({token: this.authToken}).then((response) => {
        if (response.success) {
          // Disable the Intercom when logged in through external auth
          this.$store.commit('setIsLoginExternal', { 'isLoginExternal': true });

          this.$router.replace({ 'name': 'Welcome' })
        } else {
          this.$router.replace({ 'name': 'Login', 'query': { 'failedAutologin': true } })
        }
      })
    } else {
      this.$router.replace({ 'name': 'Login'})
    }
  }
}
</script>

<style scoped>
.login-background {
  background-color: #fafafa;
}
</style>
